// Função para definir cookie
export function setCookie(name, value, options = {}) {
  const defaults = {
    days: 30,
    path: '/',
    sameSite: 'Lax'
  };
  
  const config = { ...defaults, ...options };
  
  const cookieValue = typeof value === 'object' ? JSON.stringify(value) : value;
  
  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(cookieValue)}`;
  
  // Adiciona expiração se especificada
  if (config.days) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + config.days);
    cookieString += `; expires=${expirationDate.toUTCString()}`;
  }
  
  if (config.path) {
    cookieString += `; path=${config.path}`;
  }
  
  if (config.domain) {
    cookieString += `; domain=${config.domain}`;
  }
  
  if (config.sameSite) {
    cookieString += `; SameSite=${config.sameSite}`;
  }
  
  if (config.secure) {
    cookieString += `; Secure`;
  }
  
  document.cookie = cookieString;
}

export function getCookie(name, parseJSON = true) {
  const nameEQ = encodeURIComponent(name) + "=";
  const cookies = document.cookie.split(';');
  
  for (let cookie of cookies) {
    let c = cookie.trim();
    if (c.indexOf(nameEQ) === 0) {
      const value = decodeURIComponent(c.substring(nameEQ.length));
      
      if (parseJSON) {
        try {
          return JSON.parse(value);
        } catch (e) {
          return value;
        }
      }
      
      return value;
    }
  }
  
  return null;
}

export function removeCookie(name, path = '/', domain = null) {
  let cookieString = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`;
  
  if (domain) {
    cookieString += `; domain=${domain}`;
  }
  
  document.cookie = cookieString;
}

export function cookieExists(name) {
  return getCookie(name, false) !== null;
}

export function getAllCookies() {
  const cookies = {};
  const cookieArray = document.cookie.split(';');
  
  for (let cookie of cookieArray) {
    const [name, value] = cookie.trim().split('=');
    if (name && value) {
      cookies[decodeURIComponent(name)] = decodeURIComponent(value);
    }
  }
  
  return cookies;
}

export function saveUTMParams(utmParams, options = {}) {
  const utmStructure = {
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_content: '',
    utm_term: ''
  };
  
  const existingCookie = getUTMParams() || {};
  
  const processedUTMParams = {};
  Object.keys(utmStructure).forEach(key => {
    const urlValue = utmParams[key];
    const existingValue = existingCookie[key];
    
    // Se tem valor na URL (não vazio), usa o valor da URL
    if (urlValue && urlValue.trim() !== '') {
      processedUTMParams[key] = urlValue.trim();
    }
    // Se não tem valor na URL mas tem no cookie existente, preserva o do cookie
    else if (existingValue && existingValue.trim() !== '') {
      processedUTMParams[key] = existingValue;
    }
    // Senão, usa valor vazio
    else {
      processedUTMParams[key] = '';
    }
  });
  
  // Se utm_source estiver vazio, define como "direct"
  if (!processedUTMParams.utm_source || processedUTMParams.utm_source === '') {
    processedUTMParams.utm_source = 'direct';
  }
  
  // Se utm_medium estiver vazio, define como "none"
  if (!processedUTMParams.utm_medium || processedUTMParams.utm_medium === '') {
    processedUTMParams.utm_medium = 'none';
  }
  
  const now = Date.now();
  processedUTMParams._timestamp = now;
  processedUTMParams._url = window.location.href;
  
  if (existingCookie._first_timestamp) {
    processedUTMParams._first_timestamp = existingCookie._first_timestamp;
  } else {
    processedUTMParams._first_timestamp = now;
  }
  
  const defaultOptions = {
    days: 30,
    path: '/',
    sameSite: 'Lax'
  };
  
  // Sempre salva o cookie
  setCookie('_pm3_utm', processedUTMParams, {
    ...defaultOptions,
    ...options
  });
  
  return true;
}

export function getUTMParams() {
  return getCookie('_pm3_utm');
}

export function updateUTMParams(newUTMParams, options = {}) {
  const existingUTM = getUTMParams() || {};
  const updatedUTM = { ...existingUTM, ...newUTMParams };
  
  return saveUTMParams(updatedUTM, options);
}

export function getUTMInfo() {
  const utmData = getUTMParams();
  if (!utmData) {
    return {
      exists: false,
      data: null,
      age: null,
      daysUntilExpiration: null
    };
  }
  
  const now = Date.now();
  const createdAt = utmData._first_timestamp || utmData._timestamp;
  const updatedAt = utmData._timestamp;
  
  const ageInDays = createdAt ? Math.floor((now - createdAt) / (1000 * 60 * 60 * 24)) : null;
  
  const daysUntilExpiration = createdAt ? Math.max(0, 30 - ageInDays) : null;
  
  return {
    exists: true,
    data: utmData,
    createdAt: createdAt ? new Date(createdAt) : null,
    updatedAt: updatedAt ? new Date(updatedAt) : null,
    ageInDays,
    daysUntilExpiration,
    isExpired: daysUntilExpiration === 0
  };
}

export function cleanupExpiredUTM() {
  const info = getUTMInfo();
  if (info.exists && info.isExpired) {
    removeCookie('_pm3_utm');
    return true;
  }
  return false;
}

function utmParamsEqual(params1, params2) {
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  return utmKeys.every(key => params1[key] === params2[key]);
}

export const saveUTMCookie = saveUTMParams;